/**********************************

  wp_fast_ship.js   (Teapigs)

  Cookie helpers + self-heal + race-proof polling auto-trigger.

  ZIP ACQUISITION: assets/worldpantry-ipzipcode.js (the boss's app-proxy
  file) sets the `zipcode` cookie. The old GeoLocation object -- which had
  an EXPOSED IPStack access_key, did its own api.ipstack.com call, stored
  FORMATTED dates (Firefox-unsafe) and called window.location.reload() --
  has been REMOVED, along with the ShippingForm object.

  NOTE: the proxy must be installed/responding for auto-populate to work.
  Until then, manual entry still works; cold-visit geo does not.

  AUTO-TRIGGER + BUTTON: the shipping form is now a DIV with a
  <button type="button"> (the shared panel), not a <form>. The auto-trigger
  fills the zip input, fires 'input' so the button enables, clicks the
  button, then verifies + retries if the click raced the handler binding.
  It does NOT call .submit() (a div has no submit event).

  Teapigs is banner-only (no live inventory). Shipping submit/display logic
  lives in snippets/worldpantry-fast-shipping-logic.liquid.

  LOAD ORDER: requires jQuery (loaded above this, deferred is fine).

***********************************/

var WP_FS = {
  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },
  zipInputSelector:  '.zip_input',
  zipButtonSelector: '.zip_button',
  pollIntervalMs: 250,
  pollMaxTicks:   40    // ~10s waiting for the async proxy zip
};

/**********************************
  Cookie functions
***********************************/
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/";
}

function getSessionCookie(name) {
  var nameKey = name + "=";
  var cDecoded = decodeURIComponent(document.cookie);
  var cArr = cDecoded.split("; ");
  var res;
  cArr.forEach(function (val) {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value != null ? value : "") + expires + "; path=/";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  Self-heal: clear a stuck "No Error" cookie, legacy non-ISO date cookies,
  and a stale PAST receive-by date from a previous visit so the auto-trigger
  refetches a fresh date.
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_FS.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_FS.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) deleteCookie(WP_FS.cookies.calcError);
  }

  var receiveBy = getSessionCookie(WP_FS.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_FS.cookies.orderBy);

  // Non-ISO legacy value -> unparseable -> clear.
  if ((receiveBy && isNaN(new Date(receiveBy))) ||
      (orderBy && isNaN(new Date(orderBy)))) {
    deleteCookie(WP_FS.cookies.receiveBy);
    deleteCookie(WP_FS.cookies.orderBy);
    return;
  }

  // Stale PAST date -> clear (day granularity).
  if (receiveBy) {
    var rd = new Date(receiveBy);
    if (!isNaN(rd)) {
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var day = new Date(rd.getFullYear(), rd.getMonth(), rd.getDate());
      if (day.getTime() < today.getTime()) {
        deleteCookie(WP_FS.cookies.receiveBy);
        deleteCookie(WP_FS.cookies.orderBy);
      }
    }
  }
})();

/**********************************
  Auto-trigger (race-proof polling). Once a VALID zip cookie lands, fill the
  zip input, fire 'input' so the panel button enables, click it, then verify
  a result stored and retry if the click raced the handler. Guarded to once.
***********************************/
$(document).ready(function () {
  if (window.wpZipAutoTriggered) return;
  window.wpZipAutoTriggered = true;

  var zipPollTicks = 0;
  var clickTries = 0;
  var clickMax = 10;

  function resultStored() {
    return !!getSessionCookie(WP_FS.cookies.receiveBy);
  }

  function fireAndVerify(zip) {
    if (resultStored()) return;

    console.log("fast geo zip " + zip + (clickTries ? " (retry " + clickTries + ")" : ""));
    // Fill + fire 'input' so the panel button (disabled until 5 chars)
    // enables, otherwise the click hits a disabled button and no-ops.
    $(WP_FS.zipInputSelector).val(zip).trigger('input');
    var $btn = $(WP_FS.zipButtonSelector).first();
    if ($btn.length) $btn.trigger("click");

    clickTries++;
    if (clickTries < clickMax) {
      setTimeout(function () {
        if (!resultStored()) fireAndVerify(zip);
      }, 300);
    }
  }

  function waitForZip() {
    var zip = getCookie(WP_FS.cookies.zip);
    if (isValidZip(zip)) {
      fireAndVerify(zip);
      return;
    }
    zipPollTicks++;
    if (zipPollTicks < WP_FS.pollMaxTicks) {
      setTimeout(waitForZip, WP_FS.pollIntervalMs);
    } else {
      console.log("no zipcode after polling - manual entry only");
    }
  }

  waitForZip();
});
